import {GET_MONTH} from '../Actions/types'

const initialState= { 
    daysInMonth: "",

}

export default function (state = initialState, action) {

        switch(action.type) {
            case GET_MONTH: 
                return{
                    ...state,
                    daysInMonth: action.payload
                };
                default: 
            return state;

        }
    
}


// WEBPACK FOOTER //
// ./src/Reducers/MonthChartReducer.js